// extracted by mini-css-extract-plugin
export default {"why-us-section":"WhyUs_why-us-section__iRMUr","section-content":"WhyUs_section-content__ryOdN","item-holder":"WhyUs_item-holder__WiHm4"};